import React from "react";
import NavBar from "../components/NavBar";
import HomeWorthCalculatorPage from "../components/HomeWorthCalculatorPage";
import Footer from "../components/Footer";

const HomeWorthCalculator = () => {
    return(
        <div>
            <NavBar/>
            <HomeWorthCalculatorPage/>
            <Footer/>
        </div>
    )
}

export default HomeWorthCalculator;